import IService from "@api/iService";
import {MarketCategory, MarketItem} from "@interfaces/user/market";
import {BuyItemsModel} from "@models/user/market";

export default class MarketService extends IService {

    async fetchUserMarketItems() {
        return await this.getAndThrowApi<MarketItem[]>('/api/user/market/items/');
    }

    async fetchUserMarketCategories() {
        return await this.getAndThrowApi<MarketCategory[]>('/api/user/market/categories/');
    }

    async buyMarketItem(items: BuyItemsModel) {
        return await this.postApi('/api/user/market/buy/', items);
    }
}